import { render, staticRenderFns } from "./studentPrint.vue?vue&type=template&id=48fb0e87&"
import script from "./studentPrint.vue?vue&type=script&lang=js&"
export * from "./studentPrint.vue?vue&type=script&lang=js&"
import style0 from "./studentPrint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports